<template>
  <div v-if="colors.length" class="select-color">
    <div
      class="select-color-label"
      v-if="label"
      v-text="label"
    />
    <span
      v-if="showColorName"
      class="select-color-name"
    >
      {{ colorName }}
    </span>
    <ul class="select-color-colors">
      <li
        v-for="c in computedColors"
        :title="c.name"
        :key="c.id"
        :class="{ active: c.modelId === activeColor }"
        @click.stop="select(c)"
      >
        <div v-if="c.type === 'code'" class="color-code" :style="{ backgroundColor: c.value }" />
        <media v-else :src="c.value" width="48" height="48" :alt="c.name" />
      </li>
      <li
        v-if="colorsLimit && colors.length > colorsLimit"
        @click="openProductCard"
        class="more-colors"
        v-text="`+${ colors.length - colorsLimit }`"
      />
    </ul>
  </div>
</template>

<script>
import { capitalize } from "@/utils/string-utils";

export default {
  name: 'select-color',

  props: {
    label: {
      type: String,
      default: '',
    },
    colors: {
      type: Array,
      default: () => ([]),
    },
    activeColor: { // id товара
      type: String,
      default: '',
    },
    showColorName: {
      type: Boolean,
      default: false
    },
    colorsLimit: {
      type: Number,
      default: null
    }
  },

  computed: {
    colorName() {
      let name = this.colors.find(c => this.activeColor === c.modelId)?.name;
      return capitalize(name);
    },

    computedColors() {
      return this.colorsLimit ? this.colors.slice(0, this.colorsLimit) : this.colors;
    }
  },

  methods: {
    select({ modelId = '' } = {}) {
      if (modelId === this.activeColor) return;

      this.$emit('change', modelId);
    },

    openProductCard() {
      window.location = `/product/${this.activeColor}`;
    }
  }
}
</script>

<style lang="scss">
.select-color {
  &-colors {
    list-style: none;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    li {
      position: relative;
      padding: 4px;
      margin: 8px 4px 0 0;
      border-radius: 50%;
      cursor: pointer;
      transition: .2s box-shadow;

      &:hover {
        box-shadow: inset 0 0 0 1px $gray;
      }

      &.active {
        box-shadow: inset 0 0 0 1px $black;
      }

      &::before {
        // extend click zone
        content: '';
        position: absolute;
        top: -3px;
        right: -3px;
        bottom: -3px;
        left: -3px;
      }

      img,
      .color-code {
        display: block;
        width: 16px;
        height: 16px;
        object-fit: cover;
        border-radius: 50%;
      }
    }

    .more-colors {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
      margin-left: 4px;
      border: 1px solid $gray_lu;
      border-radius: 50%;
      font-size: 10px;
      line-height: 20px;
      transition: .2s ease border-color;

      &:hover {
        border-color: $gray;
      }
    }
  }

  &-name {
    display: block;
    margin-top: 4px;
    font-size: 12px;
    font-weight: bold;
    line-height: 16px;
  }
}

@include breakpoint("desktop") {
  .select-color {
    &-colors {
      li {
        padding: 6px;

        &.active {
          box-shadow: inset 0 0 0 2px $black;
        }
      }
    }

    &-name {
      margin-top: 8px;
      font-size: 14px;
    }
  }
}
</style>
